import { GetDamagedAdjusterOtherAttachedImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterOtherAttachedImages/getDamagedAdjusterOtherAttachedImagesQuery.type';
import { getDamagedAdjusterOtherAttachedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterOtherAttachedImages/getDamagedAdjusterOtherAttachedImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedAdjusterOtherAttachedImagesQueryOptions = (
  params: GetDamagedAdjusterOtherAttachedImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['DamagedAdjusterOtherAttachedImages', params],
    queryFn: () => getDamagedAdjusterOtherAttachedImagesFunction(params),
    enabled: true,
  });
};
